<template>
	<div>
		<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
			<router-link :to="{path: '/tasks-priorities'}" class="btn btn-link">
				<font-awesome-icon :icon="['fas', 'chevron-left']"></font-awesome-icon>
			</router-link>
			<h1 class="h2">Изменение приоритета задач</h1>
			<div class="btn-toolbar mb-2 mb-md-0">
				<button type="button" class="btn btn-primary mr-2" @click="onSave()">
					<font-awesome-icon :icon="['fas', 'save']"></font-awesome-icon>
				</button>
				<button type="button" class="btn btn-danger" @click="onDelete()">
					<font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
				</button>
				<!--
				<div class="btn-group me-2">
					<button type="button" class="btn btn-sm btn-outline-secondary">Share</button>
					<button type="button" class="btn btn-sm btn-outline-secondary">Export</button>
				</div>
				<button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle">
					<span data-feather="calendar"></span>
					This week
				</button>
				-->
			</div>
		</div>
		<b-overlay :show="overlay" rounded="lg" variant="white">
			<div class="row">
				<div class="col-md-6 offset-md-3">
					<div id="input-group-id" role="group" class="form-group">
						<label id="input-group-id" for="input-id" class="d-block">ID приоритета задач:</label>
						<div>
							<input id="input-id" type="number" class="form-control" v-model="id" readonly />
						</div>
					</div>
					<div id="input-group-name" role="group" class="form-group">
						<label id="input-group-name" for="input-name" class="d-block">Название приоритета задач:</label>
						<div>
							<input id="input-name" type="text" placeholder="Например: Нормальный" class="form-control" v-model="name" autofocus />
						</div>
					</div>
					<div id="input-group-weight" role="group" class="form-group">
						<label id="input-group-weight" for="input-weight" class="d-block">Вес приоритета задач:</label>
						<div>
							<input id="input-weight" type="number" max="99" class="form-control" v-model="weight" />
						</div>
					</div>
				</div>
			</div>
		</b-overlay>
		<div class="alert alert-info" v-html="result" v-if="result != ''"></div>
	</div>
</template>

<style lang="css">

</style>

<script>
import { useMeta } from 'vue-meta';
import BOverlay from '@/components/bootstrap/overlay.vue';

export default {
	name: 'TasksPriorityList',
	setup(){
		useMeta({title: 'Изменение приоритета задач'});
	},
	data: () => ({
		overlay: true,
		
		id: '',
		name: '',
		weight: 0,
		
		result: '',
	}),
	computed: {
		token(){
			return this.$store.state.token;
		},
	},
	methods: {
		async loadData(id){
			await fetch('/api/tasks-priorities/'+id+'?' + new URLSearchParams({
				virtualspace_id: 1,
			}), {
				headers: {
					Authorization: 'Bearer '+this.token,
				},
			}).then(stream => stream.json()).then(data => {
				this.id = data.id;
				this.name = data.name;
				this.weight = data.weight;
			}).catch(error => {
				alert('Ошибка! '+error);
				console.error(error);
			});
		},
		onSave(){
			this.result = 'Сохранение...';
			this.overlay = true;
			
			let formData = new FormData();
			formData.append('virtualspace_id', 1);
			formData.append('name', this.name);
			formData.append('weight', this.weight);
			
			fetch('/api/tasks-priorities/'+this.id, {
				method: 'POST',
				body: formData,
				headers: {
					Authorization: 'Bearer '+this.token,
				},
			}).then(stream => stream.json()).then(ret => {
				if(ret.success) this.result = 'Изменения успешно сохранены';
				else this.result = '';
				this.overlay = false;
			}).catch(error => {
				console.error(error);
				this.overlay = false;
				this.result = 'Ошибка! '+error;
			});
		},
		onDelete(){
			if(confirm('Вы уверены?')){
				this.overlay = true;
				fetch('/api/tasks-priorities/'+this.id, {
					method: 'DELETE',
					headers: {
						Authorization: 'Bearer '+this.token,
					},
				}).then(stream => stream.json()).then(ret => {
					if(ret.success){
						this.$router.push('/tasks-priorities');
					} else {
						this.overlay = false;
					}
				}).catch(error => {
					console.error(error);
					this.overlay = false;
					this.result = 'Ошибка! '+error;
				});
			}
		},
	},
	async beforeMount(){
		window.scrollTo(0, 0);
		this.overlay = true;
		await this.loadData(this.$route.params.id);
		this.overlay = false;
	},
	async beforeRouteUpdate(to, from, next){
		next();
		window.scrollTo(0, 0);
		this.overlay = true;
		await this.loadData(to.params.id);
		this.overlay = false;
	},
	components: {
		BOverlay,
	},
}
</script>